export default "__VITE_ASSET__CfWfDfGK__"